"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function adaptBbvaToF2(props) {
    return {
        bbvaQuotationId: props.bbva.bbva_quotation_id,
        casualtyInsurance: props.hasInsurance,
        downpayment: props.enganche,
        exColorSelected: props.exteriorColor.slug,
        intColorSelected: props.interiorColor.slug,
        mainEmail: undefined,
        modelName: props.powerTrain.trim?.model?.name,
        modelYear: props.powerTrain.trim?.model?.year,
        montoTotal: undefined,
        pagoMensual: undefined,
        quotId: undefined,
        subName: props.subsidiary.name,
        subsidiary: props.subsidiary.caption_text,
        term: props.plazo,
        totalAPagar: undefined,
        versionId: props.powerTrain.id,
        versionName: props.powerTrain.name,
        versionPrice: props.powerTrain.price,
        webpage: props.subsidiary.webpage,
    };
}
exports.default = adaptBbvaToF2;
